var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { filesize } from 'filesize';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { NeedAuthorization } from "../../Auth";
import ShowIf from "../../App/ShowIf";
import { Translate, t } from "../../I18N";
import AttachmentForm from "./AttachmentForm";
import { wrapDispatch } from "../../Multireducer";
import { notify } from "../../Notifications/actions/notificationsActions";
import { store } from "../../store";
import { getFileExtension } from "../../utils/getFileExtension";

import {
  deleteAttachment,
  renameAttachment,
  loadForm,
  submitForm,
  resetForm } from "../actions/actions";


const getItemOptions = (filename, url) => {
  const options = {};
  options.itemClassName = '';
  options.typeClassName = 'empty';
  options.icon = 'paperclip';
  options.deletable = true;
  options.replaceable = false;
  options.downloadHref = `/api/files/${filename}`;
  options.url = url;

  return options;
};

class Attachment extends Component {
  static conformThumbnail(file, item) {
    const acceptedThumbnailExtensions = ['png', 'gif', 'jpg', 'jpeg'];
    let thumbnail = null;

    if (file.filename && getFileExtension(file.filename) === 'pdf') {
      thumbnail = /*#__PURE__*/
      _jsx("span", { "no-translate": true }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "file-pdf" }), " pdf"
      );

    }

    if (file.url) {
      thumbnail = /*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "link" })
      );

    }

    if (
    file.filename &&
    acceptedThumbnailExtensions.indexOf(getFileExtension(file.filename.toLowerCase())) !== -1)
    {
      thumbnail = /*#__PURE__*/_jsx("img", { src: item.downloadHref, alt: file.filename });
    }

    return /*#__PURE__*/_jsx("div", { className: "attachment-thumbnail" }, void 0, thumbnail);
  }

  constructor(props) {
    super(props);
    this.state = { dropdownMenuOpen: false };

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.attachmentActionsRef = /*#__PURE__*/React.createRef();
    this.onRenameSubmit = this.onRenameSubmit.bind(this);
    this.toggleRename = this.toggleRename.bind(this);
  }

  componentDidMount() {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  onRenameSubmit(newFile) {
    const { parentSharedId, model, storeKey } = this.props;
    this.props.renameAttachment(parentSharedId, model, storeKey, newFile);
  }

  toggleDropdown() {
    this.setState((prevState) => ({
      dropdownMenuOpen: !prevState.dropdownMenuOpen
    }));
  }

  deleteAttachment(attachment) {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.deleteAttachment(this.props.parentSharedId, attachment, this.props.storeKey);
      },
      title: 'Confirm delete',
      message: this.props.deleteMessage
    });
  }

  toggleRename() {
    const { file, model } = this.props;
    this.props.loadForm.bind(this, model, file)();
    this.toggleDropdown();
  }

  copyToClipboard(item) {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = item.url || window.location.origin + item.downloadHref;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);

    store.dispatch(notify(t('System', 'Copied to clipboard', null, false), 'success'));
    this.toggleDropdown();
  }

  handleClickOutside(e) {
    if (
    this.attachmentActionsRef.current &&
    !this.attachmentActionsRef.current.contains(e.target))
    {
      this.setState({ dropdownMenuOpen: false });
    }
  }

  render() {
    const { file, model, storeKey, entity } = this.props;
    const sizeString = file.size ? filesize(file.size) : '';
    const item = getItemOptions(file.filename, file.url);
    let name = /*#__PURE__*/
    _jsx("a", {
      className: "attachment-link",
      href: item.url || item.downloadHref,
      download: true,
      target: "_blank",
      rel: "noopener noreferrer" }, void 0,

    Attachment.conformThumbnail(file, item), /*#__PURE__*/
    _jsx("span", { className: "attachment-name" }, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, file.originalname), /*#__PURE__*/
    _jsx(ShowIf, { if: Boolean(sizeString) }, void 0, /*#__PURE__*/
    _jsx("span", { className: "attachment-size" }, void 0, sizeString)
    )
    )
    );


    let buttons = null;

    if (this.props.beingEdited && !this.props.readOnly) {
      name = /*#__PURE__*/
      _jsx("div", { className: "attachment-link" }, void 0,
      Attachment.conformThumbnail(file, item), /*#__PURE__*/
      _jsx("span", { className: "attachment-name" }, void 0, /*#__PURE__*/
      _jsx(AttachmentForm, { model: this.props.model, onSubmit: this.onRenameSubmit })
      )
      );


      buttons = /*#__PURE__*/
      _jsx("div", { className: "attachment-buttons" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "item-shortcut-group" }, void 0, /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "item-shortcut btn btn-primary",
        onClick: this.props.resetForm.bind(this, model) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      )
      ), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "item-shortcut btn btn-success",
        onClick: this.props.submitForm.bind(this, model, storeKey) }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "save" })
      )
      )
      )
      );

    }

    return (/*#__PURE__*/
      _jsx("div", { className: "attachment" }, void 0,
      name, /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0,
      buttons, /*#__PURE__*/

      _jsx("div", { className: "dropdown attachments-dropdown" }, void 0, /*#__PURE__*/
      _jsx("button", {
        className: "btn btn-default dropdown-toggle attachments-dropdown-toggle",
        type: "button",
        id: "attachment-dropdown-actions",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        onClick: this.toggleDropdown }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "ellipsis-h" })
      ), /*#__PURE__*/
      React.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right",
        "aria-labelledby": "attachment-dropdown-actions",
        style: { display: this.state.dropdownMenuOpen ? 'block' : 'none' },
        ref: this.attachmentActionsRef }, /*#__PURE__*/

      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: () => this.copyToClipboard(item) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "link" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Copy link")
      )
      ), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("a", {
        href: item.url || item.downloadHref,
        target: "_blank",
        rel: "noopener noreferrer",
        download: true }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "cloud-download-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Download")
      )
      ),
      !this.props.readOnly && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.toggleRename }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "font" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Rename")
      )
      ), /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.deleteAttachment.bind(this, file),
        className: "is--delete" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete")
      )
      )
      )

      )
      )
      )
      ));

  }
}

Attachment.defaultProps = {
  deleteMessage: 'Are you sure you want to delete this attachment?',
  entity: null
};




















function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
    { deleteAttachment, renameAttachment, loadForm, submitForm, resetForm },
    wrapDispatch(dispatch, props.storeKey)
  );
}

export function mapStateToProps({ attachments }, ownProps) {
  return {
    model: 'attachments.edit.attachment',
    beingEdited: ownProps.file._id && attachments.edit.attachment._id === ownProps.file._id
  };
}

export { Attachment };
export default connect(mapStateToProps, mapDispatchToProps)(withContext(Attachment));